import {Button, Col, Row, OverlayTrigger, Popover} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useAuth} from "../../providers/authprovider";
import { SketchPicker} from 'react-color';
import ResponseAlert from "../../components/ResponseAlert";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";


export default function Teams(props){

    const {privilege} = props;
    const {users} = useAuth();
    const [teams] = useState([]);
    const [workers, setWorkers] = useState(    undefined);


    useEffect(()=>{
        if(workers!==undefined)
            return;

        users.get(response=>{
            if(response.success)
                setWorkers(response.content);
        })
    })

    return (
        <div className={"container teamsBody"}>
            <Row>
                <Col className={"teamsContainer  mt-3"} lg={9}>
                    <TeamsTable privilege={privilege}  teams={teams} workers={workers} />
                </Col>
                <Col className={"workersList"} lg={3}>
                    <WorkersList  privilege={privilege} workers={workers} />
                </Col>

            </Row>


        </div>
    )
}



function TeamsTable({workers, privilege}){
    const {teams:{create, get, put, remove, deleteTeam}, user} = useAuth();
    const [teams, setTeams] = useState(undefined);
    const [alert, setAlert] = useState({show:false, error: ""});


    useEffect(()=>{
        if(teams!==undefined)
            return;

        get(({success, error, content})=>{
            console.log(content);
            if(success)
                return setTeams(content);

            setTeams([]);
            setAlert({show: true, error:error});
        })

    })


    const handleAddTeam = ()=>{
        create(({success,error, content})=>{
            if(success)
                return setTeams([...teams, content]);

            setAlert({show: true, error:error});
        })
    }

    const handleAddWorkerToTeam = (workerid, position, teamId)=>{

        const team = teams.find(t=>t.id === teamId);

        if(team === undefined)
            return;

        const worker = workers.find(w=>w.id === workerid)

        if(worker === undefined)
            return;

        put({position:position, teamId:teamId, userId:workerid}, ({success, error, content})=>{

            if(success && content === true) {
                switch (position){
                    case 0:
                        team.leader = worker;
                        break;
                    case 1:
                        team.technician1 = worker;
                        break;
                    case 2:
                        team.technician2 = worker;
                        break;
                    default:
                        return;
                }
                setTeams([...teams]);
                return;
            }

            setAlert({show:true, error: error});
        })
    }

    const handleRemoveWorker = (workerId, position, teamId)=>{

        const team = teams.find(t=>t.id === teamId);

        if(team === undefined)
            return;

        const worker = workers.find(w=>w.id === workerId)

        if(worker === undefined)
            return;

        remove({position:position, teamId:teamId, userId:workerId}, response=>{

            if(response.success && response.content === true) {
                switch (position){
                    case 0:
                        delete team.leader;
                        break;
                    case 1:
                        delete team.technician1;
                        break;
                    case 2:
                        delete team.technician2;
                        break;
                    default:
                        return;
                }
                setTeams([...teams]);
            }
            else {
                setAlert({show: true, error: response.error})
            }
        })
    }

    const handleDeleteTeam = (team)=>{
        if(!window.confirm("Potwierdź usunięcie zespołu numer: "+team.number)) return;

        deleteTeam(team.id, ({success, content, error})=>{

            if(!success)
                return window.alert(error);

            if(success)
                setTeams((prev)=>{
                    return prev.filter(t=> t.id !== team.id)
                })
        })


    }

    return (
        < >
            <ResponseAlert show={alert.show} error={alert.error} />
            <Row className={"teamsHeader"}>
                <Col lg={1}>Numer</Col>
                <Col lg={3}>Prowadzący</Col>
                <Col lg={3}>Serwisant</Col>
                <Col lg={3}>Serwisant</Col>
                {
                    user.isAdmin && <Col lg={1}>Usuń</Col>
                }
            </Row>
            {teams && teams.map(team=>
                <TeamDisplay
                    key={team.id}
                    team={team}
                    privilege={privilege}
                    onAddWorker={handleAddWorkerToTeam}
                    onRemoveWorker={handleRemoveWorker}
                    onDelete={handleDeleteTeam}
                />
            )}
            {
                privilege.edit && <Button className={"m-2"} onClick={handleAddTeam}   >Dodaj zespół</Button>
            }

        </>
    )
}

function hexToHSL(H) {
    // Convert hex to RGB first
    let r = 0, g = 0, b = 0;
    if (H.length === 4) {
        r = "0x" + H[1] + H[1];
        g = "0x" + H[2] + H[2];
        b = "0x" + H[3] + H[3];
    } else if (H.length === 7) {
        r = "0x" + H[1] + H[2];
        g = "0x" + H[3] + H[4];
        b = "0x" + H[5] + H[6];
    }

    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r,g,b),
        cmax = Math.max(r,g,b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;


    if (delta === 0)
        h = 0;
    else if (cmax === r)
        h = ((g - b) / delta) % 6;
    else if (cmax === g)
        h = (b - r) / delta + 2;
    else
        h = (r - g) / delta + 4;


    h = Math.round(h * 60);

    if (h < 0)
        h += 360;

    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));


    return {h:h, s:s, l:l};
}

function ColorPicker(props){

    const defaultValue = props.defaultValue

    const handlePickColor = (color)=>{
        props.onPick(color);
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                <SketchPicker
                    color={defaultValue.hex}
                    onChangeComplete={ handlePickColor }
                />
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger rootClose={true} trigger="click" placement="right" overlay={popover}>
            <button style={{backgroundColor:defaultValue.hex}} className={"btnColorPicker"} ></button>
        </OverlayTrigger>
    )
}

export function calcHueForPositionsHEX(hex){
    const hsl = hexToHSL(hex);
    return calcHueForPositionsHSL(hsl);
}

function calcHueForPositionsHSL(hsl){

    const h= hsl.h;
    const s = hsl.s*100;
    const l = hsl.l*100;
    const Lstep = (100-l)/3;

    return {h:h, s:s, l:l, Lstep: Lstep};
}

function TeamDisplay({team, onAddWorker, onRemoveWorker, privilege, onDelete}){


    const {teams:{setTeamColor}, user} = useAuth();

    const [color, setColor] = useState(
        ()=>{
            const hex = team.color;
            return {
                hsl: hexToHSL(hex),
                hex:hex
            }
        }
    );

    const handleDragOver = (e)=>{
        e.preventDefault();
        return false;
    }

    const handleDragEnter = (e)=>{
        e.target.classList.add('workerOver');
    }

    const handleDragLeave = (e) => {
        e.target.classList.remove('workerOver');
    }

    const handleDrop = (e, position)=>{
        e.stopPropagation();
        e.target.classList.remove('workerOver');
        const workerId = e.dataTransfer.getData('text/plain');
        if(onAddWorker !== undefined)
            onAddWorker(workerId,position,team.id);
        return false;
    }

    const handleRemoveFromTeam = (workerId, position)=>{
        if(onRemoveWorker)
            onRemoveWorker(workerId, position, team.id);
    }

    const handleColorPick = (color)=>{

        setTeamColor(color.hex, team.id, response=>{
            const {success,error} = response;

            if(success === true)
                setColor({
                    hsl:color.hsl,
                    hex:color.hex
                });
            else
                alert(error);
        });

    }

    const {h,s,l, Lstep} = calcHueForPositionsHSL(color.hsl);

    const onTeamDelete = ()=>{
        onDelete(team)
    }


    return (
        <Row className={"teamRow"}>
            <Col lg={1}>{team.number}{privilege.edit && <ColorPicker defaultValue={color} onPick={handleColorPick} />}</Col>
            <Col lg={3} className={`p-0 ${team.leader?.active ? '' : 'worker-inactive'}`}>
                <div onDragOver={handleDragOver}
                     onDragEnter={handleDragEnter}
                     onDragLeave={handleDragLeave}
                     onDrop={(e)=>{handleDrop(e, 0)}}
                     className={"workerSlot"}>
                    {team.leader?.name}
                    {team.leader && <Button className={"btn-close"} onClick={()=>handleRemoveFromTeam(team.leader.id, 0)} ></Button> }
                </div>
                <div  style={{backgroundColor:"hsl("+h+","+(s)+"%,"+(l)+"%)", height:"10%"}}></div>
            </Col>
            <Col lg={3} className={`p-0 ${team.technician1?.active ? '' : 'worker-inactive'}`}>
                <div onDragOver={handleDragOver}
                     onDragEnter={handleDragEnter}
                     onDragLeave={handleDragLeave}
                     onDrop={(e)=>{handleDrop(e, 1)}}
                     className={"workerSlot"}>
                    {team.technician1?.name}
                    {team.technician1 && <Button className={"btn-close"} onClick={()=>handleRemoveFromTeam(team.technician1.id, 1)} ></Button> }
                </div>
                <div  style={{backgroundColor:"hsl("+h+","+s+"%,"+(l+Lstep)+"%)", height:"10%"}}></div>
            </Col>
            <Col lg={3} className={`p-0 ${team.technician2?.active ? '' : 'worker-inactive'}`}>
                <div onDragOver={handleDragOver}
                     onDragEnter={handleDragEnter}
                     onDragLeave={handleDragLeave}
                     onDrop={(e)=>{handleDrop(e, 2)}}
                     className={"workerSlot"}>
                    {team.technician2?.name}
                    {team.technician2 && <Button className={"btn-close"} onClick={()=>handleRemoveFromTeam(team.technician2.id,2)} ></Button> }
                </div>
                <div  style={{backgroundColor:"hsl("+h+","+s+"%,"+(l+2*Lstep)+"%)", height:"10%"}}></div>
            </Col>
            {
                user.isAdmin &&
                <Col lg={1} className={"p-0"}>
                    <Button variant={'outline-danger'} className={"m-1"} onClick={onTeamDelete}><FontAwesomeIcon icon={faTrash} /></Button>
                </Col>
            }
        </Row>
    )
}


function WorkersList({workers}){



    return  (
        <div>
            <div>Pracownicy</div>
            {workers && workers.filter(worker=>worker.active).map(worker=><Worker key={worker.id} worker={worker} />)}
        </div>
    )
}

function Worker({worker}){

    const handleDragStart = (event)=>{
        const element = event.target;
        element.style.opacity = 0.4;

        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData("text/plain", worker.id);
    }

    const handleDragEnd = (e)=>{
        const element = e.target;
        element.style.opacity = 1;
    }

    return (
        <div draggable={true} onDragStart={handleDragStart} onDragEnd={handleDragEnd} className={"workerBlock position-relative"} id={worker.id}>
            <div><b>{worker.name}</b></div>
            <small className={"position-absolute"} style={{left:"4px", top:0}}>{worker.position}</small>
        </div>
    )
}

